import {store} from "../../store";

export const isUserAdmin = () => {
    const state = store.getState()
    return state.user.decodedTokenData?.admin || false
}

export default isUserAdmin;